'use client';

import { useFetchMemberInfoQuery } from '@module/queries/live/liveQueryHooks';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';

function TakeCoinInfoContainer() {
  const { data: myTakeCoinInfo } = useFetchMemberInfoQuery({ info: 'takeCoinInfo' });

  return (
    <div className='mb-[70px] flex items-center justify-evenly rounded-[20px] border-8 border-borderBg01 pt-5 pb-3'>
      <div className='text-center'>
        <p className='mb-1 text-center text-[#777]'>오늘 선물 받은 하트</p>
        <p className='font-extrabold font-nanum-square text-colorFg18'>
          <span className='text-[32px]'>
            {formatNumberWithComma(myTakeCoinInfo?.userInfo.takeCoinInfo?.todayTakeCoin)}
          </span>
          <span className='ml-2 text-[20px]'>개</span>
        </p>
      </div>
      <div className='h-10 w-0.5 bg-borderBg01' />
      <div className='text-center'>
        <p className='mb-1 text-center text-[#777]'>환전가능</p>
        <p className='font-extrabold font-nanum-square text-colorFg18'>
          <span className='text-[32px]'>
            {formatNumberWithComma(myTakeCoinInfo?.userInfo.takeCoinInfo?.exchangeAbleCoin)}
          </span>
          <span className='ml-2 text-[20px]'>개</span>
        </p>
      </div>
    </div>
  );
}

export default TakeCoinInfoContainer;
